import { addToCartDev } from './addToCartDev';
import { addToCartLive } from './addToCartLive';

const isDev = process.env.NODE_ENV === 'development';

export const addToCart = isDev ? addToCartDev : addToCartLive;
